import {
    Controller
} from "stimulus"
import cal from 'generate-calendar-url'

/**
 * Generate an add an ical subscription link
 */
export default class extends Controller
{
    get event() {
        const event = {
            title: this.data.get('title'),
            start: new Date(this.data.get('start')),
            end: new Date(this.data.get('end')),
        }

        if (this.data.has('location')) {
            event['location'] = this.data.get('location')
        }

        if (this.data.has('description')) {
            event['description'] = this.data.get('description')
        }

        return event
    }

    connect()
    {
        this.element.href = cal.ical(this.event)
    }
}
